// extracted by mini-css-extract-plugin
module.exports = {"checkboxMenuItem":"CheckboxMenu_checkboxMenuItem__1kJgP"};